import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    userData: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    token: null,
    refreshToken: null,
    authInfo: null
  },
  reducers: {
    setUser: (state, action) => {
      state.userData = action.payload;
      state.isAuthenticated = true;
    },
    setAuthInfo: (state, action) => {
      state.authInfo = action.payload
    },
    updateAuthInfo: (state, action) => {
      state.authInfo = null
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.token = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearUser: (state) => {
      state.userData = null;
      state.isAuthenticated = false;
      state.token = null;
    },
  },
});

export const { setUser, setLoading, setError, clearUser, setToken, setRefreshToken, setAuthInfo, updateAuthInfo } = authSlice.actions;
export default authSlice.reducer;

export const logout = () => (dispatch) => {
  // You can perform any necessary cleanup or API calls here if needed
  // For a simple logout, just dispatch clearUser
  dispatch(clearUser());
};


